import React, { useEffect, useState, useRef } from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { toast } from "react-toastify";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import MuiPagination from "../../../shares/MuiPagination";
import ReturnedOrderDetails from "./ReturnedOrderDetails";

const headersList = [
  { colName: "unique_id", name: "سند" },
  { colName: "created_at", name: "تاریخ  ثبت مرجوعی" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
  // { colName: "total", name: "مرجوعی" },
];

const mobileHeadersList = [
  { colName: "unique_id", name: "کد سفارش" },
  { colName: "created_at", name: "تاریخ  ثبت مرجوعی" },
  { colName: "total", name: "وزن" },
  // { colName: "total", name: "مرجوعی" },
];

const dataKey = ["unique_id","created_at", "total"];

const ReturnedOrderList = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);
  const { userData } = useUserData();

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
  ];

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <ReturnedOrderDetails
          selectedRow={it}
          getCompleteOrderApi={getCompleteOrderApi}
        />
      ),
    },
    // {
    //   label: "مرجوعی سفارش",
    //   component: (it) => (
    //     <ReturnOrder
    //       selectedRow={it}
    //       getCompleteOrderApi={getCompleteOrderApi}
    //     />
    //   ),
    // },
  ];

  const actionsList = [];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [receviedOerdersList, setReceviedOerdersList] = useState({
    results: [],
  });

  const getCompleteOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/customer_get_return_order`,
    params: { unique_id: fixNumbers(codeFilter) },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setReceviedOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (codeFilter !== null) {
      setIsFilterOn(true);
      getCompleteOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getCompleteOrderApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setReceviedOerdersList({ results: [] });
    getCompleteOrderApi.reFetch();
  };
  return (
    <>
      <PanelTemplate sidebarActiveLink="returned-order-list">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های مرجوع شده</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <PanelTable
            header="لیست سفارش‌های تحویل گرفته شده:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={receviedOerdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default ReturnedOrderList;
